export default __webpack_public_path__ + "static/media/Frame 10816.5ed3bcea.svg";